import React, { Component, Fragment } from 'react'
//utils
import { Translations, checkIsNA, convertStringToArray, convertStringToArrayForOption, convertStringToArrayForRadio } from '../../../../../utils';
//rest client
import { aemHostClient, taxonomyHostClient, eapiClient } from '../../../../../restClient';
import { ECHANNEL_HSBCNET, FORM_REFS } from '../../../../../constants';
import Dynamicform from '../../../../common/Dynamicform/dynamicForm';
// child component
import SimpleDropdown from '../../../../common/SimpleDropdown';
import Radiobutton from '../../../../common/Radio/radioButton';
import Checkbox from '../../../../common/Checkbox/';
// style
import './style.css'
import classNames from 'classnames';
import CCRRateBox from '../../../../common/CCRRateBox';

class IEDetailSetting extends Component {

  state = {
    contributionVal: '',
    showContent: true,
    dropdown_productParticipatingIn: [],
    detailedSettings: [
      {
        country: "",
        accountId: "",
        currency: '',
        odLimit: "N/A",
        checkODLimit: true,
        interestContribution: {
          name: 'Interest Contribution',
          value: 'Interest Contribution'
        },
        baseRateCredit: {
          baseRate: "",
          baseRateCode: "",
          spread: "",
          rate: "",
          marginBaseRate: '',
          fixedValue: false,
          minimumInterest: '',
          maximumInterest: ''
        },
        baseRateDebit: {
          baseRate: "",
          baseRateCode: "",
          spread: "",
          rate: "",
          fixedValue: false,
          marginBaseRate: '',
          minimumInterest: '',
          maximumInterest: ''
        },
        unauthorizedInterestType: "marginBaseRate",
        unauthorizedOD: {
          baseRate: "",
          baseRateCode: "",
          spread: "",
          fixedValue: 'false',
          marginBaseRate: '',
          minimumInterest: '',
          maximumInterest: ''
        },
        tiers: []
      }
    ],
    newTiers: [],
    iefDropdown: [],
    accountInterestEnhances: [],
    eChannels: []
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  setInputvalue(key, index, value, name, event) {
    let newDetailSetting = this.state.detailedSettings

    if (index === 'creditMarginBaseRate') {
      if ('baseRateCredit' in newDetailSetting[key]) {
        newDetailSetting[key].baseRateCredit.marginBaseRate = value
        newDetailSetting[key].baseRateCredit.fixedValue = ''
      } else {
        newDetailSetting[key] = {
          baseRateCredit: {
            ...newDetailSetting[key].baseRateCredit,
            marginBaseRate: value,
            fixedValue: ''
          },
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    } else if (index === 'creditFixedValue') {
      if ('baseRateCredit' in newDetailSetting[key]) {
        newDetailSetting[key].baseRateCredit.fixedValue = value
        newDetailSetting[key].baseRateCredit.marginBaseRate = ''
      } else {
        newDetailSetting[key] = {
          baseRateCredit: {
            ...newDetailSetting[key].baseRateCredit,
            fixedValue: value,
            marginBaseRate: ''
          },
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    } else if (index === 'debitMarginBaseRate') {
      if ('baseRateDebit' in newDetailSetting[key]) {
        newDetailSetting[key].baseRateDebit.marginBaseRate = value
        newDetailSetting[key].baseRateDebit.fixedValue = value
      } else {
        newDetailSetting[key] = {
          baseRateDebit: {
            ...newDetailSetting[key].baseRateDebit,
            marginBaseRate: value,
            fixedValue: ''
          },
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    } else if (index === 'debitFixedValue') {
      if ('baseRateDebit' in newDetailSetting[key]) {
        newDetailSetting[key].baseRateDebit.fixedValue = value
        newDetailSetting[key].baseRateDebit.marginBaseRate = ''
      } else {
        newDetailSetting[key] = {
          baseRateDebit: {
            ...newDetailSetting[key].baseRateDebit,
            fixedValue: value,
            marginBaseRate: ''
          },
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    } else if (index === 'unauthorizedODFixedValue') {
      if ('unauthorizedOD' in newDetailSetting[key]) {
        newDetailSetting[key].unauthorizedOD.fixedValue = value
        newDetailSetting[key].unauthorizedOD.marginBaseRate = ''
      } else {
        newDetailSetting[key] = {
          unauthorizedOD: {
            ...newDetailSetting[key].unauthorizedOD,
            fixedValue: value,
            marginBaseRate: ''
          },
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    } else if (index === 'unauthorizedODMarginBaseRate') {
      if ('unauthorizedOD' in newDetailSetting[key]) {
        newDetailSetting[key].unauthorizedOD.fixedValue = ''
        newDetailSetting[key].unauthorizedOD.marginBaseRate = value
      } else {
        newDetailSetting[key] = {
          unauthorizedOD: {
            ...newDetailSetting[key].unauthorizedOD,
            fixedValue: '',
            marginBaseRate: value
          },
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    } else if (index === 'unauthorisedFloatingInterest') {
      if ('unauthorizedInterestType' in newDetailSetting[key]) {
        newDetailSetting[key].unauthorizedInterestType = value
      } else {
        newDetailSetting[key] = {
          unauthorizedInterestType: value,
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    } else if (index === 'unauthorisedFixedInterest') {
      if ('unauthorizedInterestType' in newDetailSetting[key]) {
        newDetailSetting[key].unauthorizedInterestType = value
      } else {
        newDetailSetting[key] = {
          unauthorizedInterestType: value,
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    } else if (index === 'checkODLimit') {
      if ('checkODLimit' in newDetailSetting[key]) {
        newDetailSetting[key].checkODLimit = checkIsNA(value, true)
      } else {
        newDetailSetting[key] = {
          checkODLimit: checkIsNA(value, true),
          ...newDetailSetting[key],
          accountId: newDetailSetting[key].accountId,
          country: newDetailSetting[key].country,
          currency: newDetailSetting[key].currency
        }
      }
    }

    this.setState({
      detailedSettings: newDetailSetting
    })


    this.props.getIETierAndSettingData(this.state.detailedSettings)

  }
  componentWillMount() {
    if (typeof this.props.interestEnhancement.detailedSettings !== 'undefined') {
      let settingData = this.props.interestEnhancement.detailedSettings;

      for (let i = 0; i < settingData.length; i++) {
        if (settingData !== undefined) {
          if ("baseRateCredit" in settingData[i]) {
            if ("marginBaseRate" in settingData[i].baseRateCredit === false) {
              settingData[i]['baseRateCredit'].fixedValue = false
            }
          }
          else {
            settingData[i]['baseRateCredit'] = {
              fixedValue: false
            }
          }

          if ("baseRateDebit" in settingData[i]) {
            if ("marginBaseRate" in settingData[i].baseRateDebit === false) {
              settingData[i]['baseRateDebit'].fixedValue = false
            }
          }
          else {
            settingData[i]['baseRateDebit'] = {
              fixedValue: false
            }
          }

          if ("unauthorizedInterestType" in settingData[i] === false) {
            settingData[i].unauthorizedInterestType = "marginBaseRate"
          }
          if ("odLimit" in settingData[i] === false) {
            settingData[i].odLimit = "N/A"
          }
        }
      }
      this.setState({
        detailedSettings: settingData
      })
    }
    aemHostClient("/aemData/formData/json_interest-enhancement-detailed-settings-page")
      .then(async ({ data }) => {
        this.setState({
          detailSettingJson: data.par
        });
        this.setContributionOptions();

        if (data && data.par && data.par.aemform_newDetailedSettings.formRef) {
          const formRef = data.par.aemform_newDetailedSettings.formRef;
          const url = FORM_REFS[formRef];
          const { data: accountLimitJson } = await aemHostClient(url)
          const { guidedropdownlist_productParticipatingIn } = accountLimitJson && accountLimitJson.guideContainer.rootPanel.items
          if (guidedropdownlist_productParticipatingIn.apiUrl) {
            const { data: productParticipatingIn } = await taxonomyHostClient(this.translations(guidedropdownlist_productParticipatingIn.apiUrl))

            this.setState({
              cachedResourceData: { dropdown_productParticipatingIn: productParticipatingIn, formSchema: accountLimitJson }
            })
          }
        }
      });


    aemHostClient("/aemData/formData/json_cashcon-all-closed")
      .then(({ data }) => {
        this.setState({ pageJson: data });
        this.getTaxanomyUrl();
      })
  }

  getTaxanomyUrl = () => {
    let eChannels = this.props.eChannels;
    taxonomyHostClient(this.translations(this.state.pageJson.par.aemform_echannelReporting.countryTaxonomy))
      .then(({ data }) => {
        if (data.responseData !== undefined) {
          let currentListCountries = data.responseData.classificationNodes;
          if (eChannels !== undefined) {
            eChannels = eChannels.map(item => {
              currentListCountries.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.country.value) {
                    item.country.name = countItem.name
                  }
                }
                return item;
              });

              this.setState([...eChannels]);
            });
          }
        }
      });
  }

  setContributionOptions = () => {
    if (this.state.detailSettingJson !== undefined && this.state.detailSettingJson.length !== 0) {
      var convertedArray = this.translateWord(this.state.detailSettingJson.staticText_detailedSettings.options);
      let newArr = convertedArray.map((item) => {
        return {
          id: item,
          name: item
        }
      })
      this.setState({
        iefDropdown: newArr
      });
    }
  }

  componentDidUpdate() {
    if (typeof this.props.interestEnhancement.detailedSettings !== 'undefined' && this.props.interestEnhancement.detailedSettings.length > 0) {
      this.props.interestEnhancement.detailedSettings.map((item, index) => {
        var content = document.querySelectorAll('[data-content]')[index];
        if ('interestContribution' in item && content !== undefined) {
          if (item.interestContribution.value.toLowerCase().replace(/\s/g, "") === 'balancecontributiononly') {
            content.style.display = "none";
          }
        }
        return item
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    var detailTiersLen = [...this.props.interestEnhancement.detailedSettings];

    if (nextProps.newTiers.length > 0 && typeof nextProps.newTiers !== 'undefined' && Array.isArray(nextProps.newTiers)) {

      detailTiersLen.map((item, index) => {
        if (nextProps.newTiers.length >= 1 && detailTiersLen[index].tiers !== undefined) {
          if (item.tiers.length < nextProps.newTiers.length) {
            var newTiersLgn = nextProps.newTiers.length - item.tiers.length;
            for (let i = 0; newTiersLgn > i; i++) {
              detailTiersLen[index].tiers.push(JSON.parse(JSON.stringify(nextProps.newTiers[i])));
            }
            this.setState({
              detailedSettings: detailTiersLen,
              newTiers: nextProps.newTiers,
            });
          }
          else {
            if (nextProps.deletedIndex !== undefined && nextProps.deletedIndex !== '') {

              detailTiersLen[index].tiers.splice(nextProps.deletedIndex, 1);

              this.props._resetDeletedIndex();
              this.setState({
                detailedSettings: detailTiersLen,
                newTiers: nextProps.newTiers,
              });
            }
          }
        }
      })

    }
    else if (nextProps.oldTiers.tiers.length > 0) {
      var _oldTiers = [...nextProps.oldTiers.tiers];
      var obj = {};
      var updatedTiers = []
      var _tiers = _oldTiers.map(item => {
        obj.balanceForEnhancementMargin = '';
        obj.balanceEligibleAccountsForPremiumMargin = '';
        obj.tierId = null;
        updatedTiers.push(obj)
      })

      detailTiersLen.map((item, index) => {
        if (_oldTiers.length >= 1 && detailTiersLen[index].tiers !== undefined) {
          if (item.tiers.length < _oldTiers.length) {
            for (let i = 0; _oldTiers.length > i; i++) {
              detailTiersLen[index].tiers.push(JSON.parse(JSON.stringify(updatedTiers[i])));
            }
            this.setState({
              detailedSettings: detailTiersLen,
              newTiers: _oldTiers,
            });
          }
        }
      })
    }

    if (nextProps.updatedDetail.length > 1) {
      this.setState({
        detailedSettings: detailTiersLen
      })
    } else {
      this.setState({
        detailedSettings: detailTiersLen,
        newTiers: nextProps.oldTiers.tiers,
      });
    }
    this.setContributionOptions();
    this.props.getIETierAndSettingData(this.state.detailedSettings)
    if (nextProps.eChannels && this.props.eChannels && nextProps.eChannels.length !== this.props.eChannels.length) {
      this.setState({
        eChannels: nextProps.eChannels
      })
    }
  }

  getData = (event, index, item, key) => {
    let val = event.target.value;
    let selectedRef = `contriContent_${index}`;

    // if(val === 'Contribution Only'){
    //   this[selectedRef].style.display = "none";
    // }else {
    //   this[selectedRef].style.display = "block";
    // }

    let newDetailSetting = this.state.detailedSettings;

    if (event.target.name === 'baseRateCredit') {
      if ('baseRateCredit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateCredit.baseRate = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            baseRate: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }

    } else if (event.target.name === 'creditCode') {
      if ('baseRateCredit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateCredit.baseRateCode = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            baseRateCode: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'creditSpread') {
      if ('baseRateCredit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateCredit.spread = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            spread: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'creditMinInterest') {
      if ('baseRateCredit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateCredit.minimumInterest = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            minimumInterest: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'creditMaxInterest') {
      if ('baseRateCredit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateCredit.maximumInterest = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            maximumInterest: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'baseRateDebit') {
      if ('baseRateDebit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateDebit.baseRate = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateDebit: {
            baseRate: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'debitCode') {
      if ('baseRateDebit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateDebit.baseRateCode = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateDebit: {
            baseRateCode: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'debitSpread') {
      if ('baseRateDebit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateDebit.spread = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateDebit: {
            spread: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'debitMinInterest') {
      if ('baseRateDebit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateDebit.minimumInterest = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateDebit: {
            minimumInterest: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'debitMaxInterest') {
      if ('baseRateDebit' in newDetailSetting[index]) {
        newDetailSetting[index].baseRateDebit.maximumInterest = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateDebit: {
            maximumInterest: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'unauthorizedODbaseRate') {
      if ('unauthorizedOD' in newDetailSetting[index]) {
        newDetailSetting[index].unauthorizedOD.baseRate = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          unauthorizedOD: {
            baseRate: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'unauthorizedODCode') {
      if ('unauthorizedOD' in newDetailSetting[index]) {
        newDetailSetting[index].unauthorizedOD.baseRateCode = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          unauthorizedOD: {
            baseRateCode: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'unauthorizedODSpread') {
      if ('unauthorizedOD' in newDetailSetting[index]) {
        newDetailSetting[index].unauthorizedOD.spread = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          unauthorizedOD: {
            spread: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'unauthorizedODMinInterest') {
      if ('unauthorizedOD' in newDetailSetting[index]) {
        newDetailSetting[index].unauthorizedOD.minimumInterest = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          unauthorizedOD: {
            minimumInterest: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'unauthorizedODMaxInterest') {
      if ('unauthorizedOD' in newDetailSetting[index]) {
        newDetailSetting[index].unauthorizedOD.maximumInterest = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          unauthorizedOD: {
            maximumInterest: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'odLimit') {
      if ('odLimit' in newDetailSetting[index]) {
        newDetailSetting[index].odLimit = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          odLimit: val,
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'balanceForEnhancementMargin') {
      if ('tiers' in newDetailSetting[index] && newDetailSetting[index].tiers.length > 0) {
        newDetailSetting[index].tiers[key].balanceForEnhancementMargin = val
      }
    } else if (event.target.name === 'balanceEligibleAccountsForPremiumMargin') {
      if ('tiers' in newDetailSetting[index] && newDetailSetting[index].tiers.length > 0) {
        newDetailSetting[index].tiers[key].balanceEligibleAccountsForPremiumMargin = val
      }
    } else if (event.target.name === 'iban') {
      if ('iban' in newDetailSetting[index]) {
        newDetailSetting[index].iban = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          iban: val,
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'extAccountNumber') {
      if ('extAccountNumber' in newDetailSetting[index]) {
        newDetailSetting[index].extAccountNumber = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          extAccountNumber: val,
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    } else if (event.target.name === 'internalAccountNumber') {
      if ('internalAccountNumber' in newDetailSetting[index]) {
        newDetailSetting[index].internalAccountNumber = val
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          internalAccountNumber: val,
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
      }
    }
    else if (event.target.name === 'productParticipatingIn') {
      if ('productParticipatingIn' in newDetailSetting[index]) {
        newDetailSetting[index].productParticipatingIn.value = val;
        newDetailSetting[index].productParticipatingIn.name = event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text;
        this[selectedRef].style.display = "block";
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          productParticipatingIn: {
            name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
            value: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
        this[selectedRef].style.display = "block";
      }
    }
    else if (val === 'Interest Contribution') {
      if ('interestContribution' in newDetailSetting[index]) {
        newDetailSetting[index].interestContribution.value = val;
        newDetailSetting[index].interestContribution.name = val;
        this[selectedRef].style.display = "block";
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          interestContribution: {
            name: val,
            value: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
        this[selectedRef].style.display = "block";
      }
    } else if (val === 'Balance Contribution Only') {
      if ('interestContribution' in newDetailSetting[index]) {
        newDetailSetting[index].interestContribution.value = val;
        newDetailSetting[index].interestContribution.name = val;
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          baseRateCredit: {
            baseRate: "",
            baseRateCode: "",
            spread: "",
            rate: "",
            marginBaseRate: '',
            fixedValue: false,
            minimumInterest: '',
            maximumInterest: ''
          },
          baseRateDebit: {
            baseRate: "",
            baseRateCode: "",
            spread: "",
            rate: "",
            fixedValue: false,
            marginBaseRate: '',
            minimumInterest: '',
            maximumInterest: ''
          },
          unauthorizedInterestType: "marginBaseRate",
          unauthorizedOD: {
            baseRate: "",
            baseRateCode: "",
            spread: "",
            fixedValue: 'false',
            marginBaseRate: '',
            minimumInterest: '',
            maximumInterest: ''
          },
          tiers: [{ balanceForEnhancementMargin: "", balanceEligibleAccountsForPremiumMargin: "", tierId: null }]
        }
        this[selectedRef].style.display = "none";
      } else {
        newDetailSetting[index] = {
          ...newDetailSetting[index],
          interestContribution: {
            name: val,
            value: val
          },
          accountId: newDetailSetting[index].accountId,
          country: newDetailSetting[index].country,
          currency: newDetailSetting[index].currency
        }
        this[selectedRef].style.display = "none";
      }
    }

    this.setState({
      detailedSettings: newDetailSetting
    })

    this.props.getIETierAndSettingData(this.state.detailedSettings)
  }

  setTiersData = (tier, item, key, event) => {
    let val = event.target.value;
    //let newDetailSetting = [...this.state.detailedSettings];

    var updatedClone = this.state.detailedSettings.map((id, keys) => {
      if (keys === key) {
        id.tiers.map((i, k) => {
          if (k === item) {
            if (event.target.name === 'balanceForEnhancementMargin') {
              i.balanceForEnhancementMargin = val
            } else if (event.target.name === 'balanceEligibleAccountsForPremiumMargin') {
              i.balanceEligibleAccountsForPremiumMargin = val
            }
          }
        })
      }
      return id
    })

    this.setState({
      detailedSettings: updatedClone
    })
    this.props.getIETierAndSettingData(this.state.detailedSettings)
  }

  dublicateSettings = (value, key) => {
    var dublicateData = this.state.detailedSettings.map((item, index) => {
      let selectedRef = `contriContent_${index}`;
      if (item.country === value.country && item.currency === value.currency) {
        item.country = value.country
        item.currency = value.currency
        item.baseRateCredit = value.baseRateCredit
        item.baseRateDebit = value.baseRateDebit
        item.unauthorizedOD = value.unauthorizedOD
        item.interestContribution = {
          name: 'Interest Contribution',
          value: 'Interest Contribution'
        }
        item.odLimit = value.odLimit
        item.unauthorizedInterestType = value.unauthorizedInterestType
        item.tiers = value.tiers
        this[selectedRef].style.display = "block";
        return item;
      } if (item.country !== value.country && item.currency !== value.currency) {
        return item;
      }
      return item;
    })

    this.setState({
      detailedSettings: dublicateData
    })
    this.props.getIETierAndSettingData(this.state.detailedSettings)
  }

  setODLimit = (event, key) => {
    let selRef = `disableODLimit_${key}`
    let newDetailSetting = this.state.detailedSettings;

    if (event.target.checked) {
      newDetailSetting[key].checkODLimit = event.target.checked;
      newDetailSetting[key].odLimit = 'N/A'
      this[selRef].disabled = event.target.checked
    } else {
      newDetailSetting[key].checkODLimit = event.target.checked;
      newDetailSetting[key].odLimit = ''
      this[selRef].disabled = event.target.checked
    }

    this.setState({
      detailedSettings: newDetailSetting
    })

    this.props.getIETierAndSettingData(this.state.detailedSettings)
  }
  _setAccountheading = (item) => {
    let setAcountjsx = [];
    this.props.accounts !== undefined && this.props.accounts.filter((otherAcc) => {
      if (otherAcc.id === item.accountId) {
        if (otherAcc.otherAccount !== undefined && 'otherAccount' in otherAcc && otherAcc.otherAccount === true) {
          setAcountjsx.push(
            <span>
              {`${otherAcc.accountNumber !== undefined ? otherAcc.accountNumber + ',' : ''}`}
              {`${otherAcc.branchCode !== undefined ? otherAcc.branchCode + ',' : ''}`}
              {`${otherAcc.country !== undefined && otherAcc.country.name !== undefined ? otherAcc.country.name + ',' : ''}`}
              {`${otherAcc.currency !== undefined && otherAcc.currency.name !== undefined ? otherAcc.currency.name : ''}`}
            </span>
          )
        } else {
          setAcountjsx.push(
            <span>
              {`${otherAcc.accountType !== undefined ? otherAcc.accountType.name + ',' : ''}`}
              {`${otherAcc.country !== undefined && otherAcc.country.name !== undefined ? otherAcc.country.name + ',' : ''}`}
              {`${otherAcc.currency !== undefined && otherAcc.currency.name !== undefined ? otherAcc.currency.name + ',' : ''}`}
              <span style={{ display: 'block', marginLeft: '140px' }}>{`${otherAcc.hsbcEntity !== undefined ? otherAcc.hsbcEntity : ''}`}</span>
            </span>
          )
        }
      }
    })
    return setAcountjsx;
  }

  getaccountInterestEnhanceData = (index, accountInterestEnhanceData) => {
    let newDetailSetting = this.state.detailedSettings
    var newAccountInterestEnhances = [...this.state.accountInterestEnhances];
    newAccountInterestEnhances[index] = accountInterestEnhanceData;

    if (accountInterestEnhanceData) {
      newDetailSetting[index].iban = accountInterestEnhanceData.iban
      newDetailSetting[index].extAccountNumber = accountInterestEnhanceData.extAccountNumber
      newDetailSetting[index].internalAccountNumber = accountInterestEnhanceData.internalAccountNumber
      newDetailSetting[index].glsReports = accountInterestEnhanceData.glsReports
      newDetailSetting[index].productParticipatingIn = accountInterestEnhanceData.productParticipatingIn
    }

    this.setState({
      accountInterestEnhances: newAccountInterestEnhances,
      detailedSettings: newDetailSetting
    })

    this.props.getIETierAndSettingData(this.state.detailedSettings)
  }
  renderEachAccountInterestAndLimit = (accountInterestEnhance, index) => {
    var formData = {};
    let glsReports = []
    let productParticipatingIn = {}

    if (accountInterestEnhance !== undefined && accountInterestEnhance.accountId !== undefined) {
      formData = { ...accountInterestEnhance }
      if ("iban" in accountInterestEnhance === false) {
        formData['iban'] = '';
      }
      if ("extAccountNumber" in accountInterestEnhance === false) {
        formData['extAccountNumber'] = ''
      }
      if ("internalAccountNumber" in accountInterestEnhance === false) {
        formData['internalAccountNumber'] = ''
      }
      if ('glsReports' in formData === false) {
        formData.glsReports = glsReports;
      } if ('productParticipatingIn' in formData === false) {
        formData.productParticipatingIn = productParticipatingIn;
      }
    } else {
      formData['iban'] = '';
      formData['extAccountNumber'] = '';
      formData['internalAccountNumber'] = '';
      formData.glsReports = glsReports;
      formData.productParticipatingIn = productParticipatingIn;

    }
    var formHeader = (
      <div >
      </div>
    );

    const properties = {
      glsCashconId: this.props.match.params.productId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'gls-cashcon-aacount-interest-and-limits',
      pathname: this.props.history.location.pathname,
      accountInterestLimitIndex: index
    };

    if (this.state.detailSettingJson !== undefined && this.state.detailSettingJson.aemform_newDetailedSettings !== undefined) {
      var aemform = this.state.detailSettingJson.aemform_newDetailedSettings;
      var formRef = this.state.detailSettingJson.aemform_newDetailedSettings.formRef;
      if (aemform !== undefined && formRef !== undefined) {
        var url = FORM_REFS[formRef];
        return (
          <div className='iedetails-section'>
            <Dynamicform mode="edit" key={accountInterestEnhance.id}
              properties={properties}
              hideButtons={true}
              getFormData={this.getaccountInterestEnhanceData.bind(this, index)}
              history={this.props.history}
              fieldPrefix={accountInterestEnhance.id}
              formHeader={formHeader}
              url={url}
              lang={this.props.lang.currentLang.lang}
              translatedData={this.props.lang.translatedData}
              isRepeatingComponentWithSameResourceUrl={true}
              cachedResourceData={this.state.cachedResourceData}
              reportingEchannels={(this.props.eChannels && this.props.eChannels.length &&
                this.props.eChannels.filter(eChannel => eChannel.eChannelType && eChannel.eChannelType.name === "HSBCnet")) || []}
              isEchannelRestricted={true}
              requiredFields={{
                "row1": ["eChannelType", "country"],
                "row2": ["profileOwner"],
                "row3": ["eChannelId"]
              }}
              pageState={this.props.pageState}
              disabledList={this.state.accountInterestEnhances && this.state.accountInterestEnhances[index] &&
                this.state.accountInterestEnhances[index]["glsReports"]}
              formatters={{
                "row1": [null, (data, fieldValue) => data.newEchannel ? `${fieldValue} (New)` : `${fieldValue} (Existing)`, null],
                "row2": [],
                "row3": []
              }}
              navigatedFrom="gls-ie-detailed-settings"
              handleGlsReportingApplyToAll={(reportIndex, eChannelId) => {
                const newDetailedSettings = [...this.state.detailedSettings]
                newDetailedSettings.forEach(account => {
                  if (reportIndex > -1 && account.glsReports) {
                    account.glsReports[reportIndex] = eChannelId
                  }
                })
                this.setState({
                  detailedSettings: newDetailedSettings
                })
              }}
            />
          </div>
        );
      }
    }
  }

  getCCrRateId = (name, fieldPrefix = '', isAggregate, parentFormName, formIndex) => {
    return isAggregate ? `${fieldPrefix}${name}${parentFormName}${formIndex}Field` : `${fieldPrefix || ""}${name}Field`
  }

  generateCCRRateBoxJsx = ({ name, boxLabel, subLabels, subNames, radioValues, isVisible, maxChars, isAggregate, parentFormName, formData, formIndex, defaultValue }, elementKey = 'ccrratebox-ie-odlimit') => {
    const visibilityCss = classNames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    const disabled = this.props.disabled
    const boxLabelTranslated = this.translations(boxLabel);
    const currentWord = this.translations(subLabels)
    const convertedArray = (typeof currentWord === "string" && convertStringToArrayForOption(currentWord)) || [];

    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={this.getCCrRateId(name, this.props.fieldPrefix, isAggregate, parentFormName, formIndex)}>
        <div className="col-lg-12 col-sm-12">
          <CCRRateBox
            name={isAggregate ? parentFormName + name + formIndex : name}
            boxLabel={boxLabelTranslated}
            disabled={disabled}
            subLabels={convertedArray}
            subNames={subNames}
            radioValues={radioValues}
            maxChars={maxChars}
            defaultValue={defaultValue}
            _value={formData}
            setInputvalue={(values) => {
              const newDetailedSettings = this.state[parentFormName] ? [...this.state[parentFormName]] : []
              if (isAggregate) {
                if (newDetailedSettings[formIndex] && "unauthorizedOD" in newDetailedSettings[formIndex]) {
                  newDetailedSettings[formIndex].unauthorizedOD = values
                } else {
                  newDetailedSettings[formIndex] = { ...newDetailedSettings[formIndex], unauthorizedOD: values }
                }
              }
              this.setState({ [parentFormName]: newDetailedSettings })
            }}
            fieldPrefix={this.props.fieldPrefix} />
        </div>
      </div>
    );
    return _jsx;
  }

  render() {
    if (typeof this.props.interestEnhancement !== 'undefined' && this.state.detailSettingJson !== undefined && this.state.detailSettingJson.staticText_detailedSettings !== undefined) {
      return [
        this.state.detailedSettings.map((item, key) =>
          <div className="detail-setting" key={key}>
            <div className="detail-setting--header-section">
              <dl className="detail-setting--datalist">
                <dt className="detail-setting--datalist__data_t">{this.translations(this.state.detailSettingJson.staticText_detailedSettings.country)}</dt>
                <dd className="detail-setting--datalist__data_d">{item.country}</dd>

                <dt className="detail-setting--datalist__data_t">{this.translations(this.state.detailSettingJson.staticText_detailedSettings.account)}</dt>
                <dd className="detail-setting--datalist__data_d">
                  {this._setAccountheading(item)}
                </dd>
              </dl>
            </div>
            <div className="detail-setting--body-section">
              {this.renderEachAccountInterestAndLimit(item, key)}
              <div className="detail-setting--body-section-row gdocs-pbottom-25">
                <div className="gdocs-pright-30">
                  <label className="gdocs-mtop-10">{this.translations(this.state.detailSettingJson.staticText_detailedSettings.interestContribution)}</label>
                </div>
                <div className='iefContibution-dropdown'>
                  {
                    this.state.iefDropdown !== undefined && this.state.iefDropdown.length !== 0 ?
                      <SimpleDropdown
                        options={this.state.iefDropdown}
                        value={typeof item.interestContribution === 'object' ? item.interestContribution.value : 'Interest Contribution'}
                        _onChange={(event) => this.getData(event, key, item)}
                        showPleaseSelectOption={false}
                        optionTextSelector="name"
                        name="contribution_list"
                        disabled={this.props.disabled}
                      />
                      : ''
                  }

                </div>
              </div>
              {
                <div ref={node => this[`contriContent_${key}`] = node} data-content={`contriContent_${key}`}>
                  <h1>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.credit)}</h1>
                  <div className="detail-setting--body-section-row">
                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.baseRate)}</label>
                      <input
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="baseRateCredit"
                        disabled={this.props.disabled}
                        maxLength="50"
                        value={typeof item.baseRateCredit === 'object' ? item.baseRateCredit.baseRate : ''}
                      />
                    </div>
                    {!this.props.disabled
                      ? <div className="row-field">
                        <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.code)}</label>
                        <input
                          type="text"
                          onChange={(event) => this.getData(event, key, item)}
                          name="creditCode"
                          maxLength="5"
                          value={typeof item.baseRateCredit === 'object' ? item.baseRateCredit.baseRateCode : ''}
                          placeholder={this.state.detailSettingJson.staticText_detailedSettings.defaultValue && this.state.detailSettingJson.staticText_detailedSettings.defaultValue[1]}
                        />
                      </div>
                      : ''}

                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.spread)}</label>
                      <input
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="creditSpread"
                        disabled={this.props.disabled}
                        maxLength="7"
                        value={typeof item.baseRateCredit === 'object' ? item.baseRateCredit.spread : ''}
                      />
                    </div>
                    <div className="row-field select-radio">
                      <label className="radio-group gdocs-mright-30">
                        <Radiobutton
                          name={`creditPremium_${key}`}
                          disabled={this.props.disabled}
                          value='true'
                          _value={typeof item.baseRateCredit !== 'undefined' ? item.baseRateCredit.marginBaseRate : ''}
                          setInputvalue={this.setInputvalue.bind(this, key, 'creditMarginBaseRate')}
                        />
                        {this.translations(this.state.detailSettingJson.staticText_detailedSettings.margin)}
                      </label>
                      <label className="radio-group">
                        <Radiobutton
                          name={`creditPremium_${key}`}
                          disabled={this.props.disabled}
                          value='false'
                          _value={typeof item.baseRateCredit !== 'undefined' ? item.baseRateCredit.fixedValue : ''}
                          setInputvalue={this.setInputvalue.bind(this, key, 'creditFixedValue')}
                        />
                        {this.translations(this.state.detailSettingJson.staticText_detailedSettings.fixedValue)}
                      </label>
                    </div>
                  </div>
                  <div className="detail-setting--body-section-row">
                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.minInterest)}</label>
                      <input
                        placeholder={this.state.detailSettingJson.staticText_detailedSettings.defaultValue[5]}
                        type="text"
                        maxLength="10"
                        onChange={(event) => this.getData(event, key, item)}
                        name="creditMinInterest"
                        disabled={this.props.disabled}
                        value={typeof item.baseRateCredit === 'object' ? item.baseRateCredit.minimumInterest : ''}
                      />
                    </div>
                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.maxInterest)}</label>
                      <input
                        placeholder={this.state.detailSettingJson.staticText_detailedSettings.defaultValue[6]}
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="creditMaxInterest"
                        disabled={this.props.disabled}
                        maxLength="10"
                        value={typeof item.baseRateCredit === 'object' ? item.baseRateCredit.maximumInterest : ''}
                      />
                    </div>
                  </div>
                  <h1>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.debit)}</h1>
                  <div className="detail-setting--body-section-row">
                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.baseRate)}</label>
                      <input
                        type="text"
                        name="baseRateDebit"
                        disabled={this.props.disabled}
                        maxLength="50"
                        onChange={(event) => this.getData(event, key, item)}
                        value={typeof item.baseRateDebit === 'object' ? item.baseRateDebit.baseRate : ''}
                      />
                    </div>
                    {!this.props.disabled
                      ? <div className="row-field">
                        <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.code)}</label>
                        <input
                          type="text"
                          name="debitCode"
                          maxLength="5"
                          onChange={(event) => this.getData(event, key, item)}
                          value={typeof item.baseRateDebit === 'object' ? item.baseRateDebit.baseRateCode : ''}
                          placeholder={this.state.detailSettingJson.staticText_detailedSettings.defaultValue && this.state.detailSettingJson.staticText_detailedSettings.defaultValue[1]}
                        />
                      </div>
                      : ''}

                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.spread)}</label>
                      <input
                        type="text"
                        name="debitSpread"
                        disabled={this.props.disabled}
                        maxLength="7"
                        onChange={(event) => this.getData(event, key, item)}
                        value={typeof item.baseRateDebit === 'object' ? item.baseRateDebit.spread : ''}
                      />
                    </div>
                    <div className="row-field select-radio">
                      <label className="radio-group gdocs-mright-30">
                        <Radiobutton
                          setInputvalue={this.setInputvalue.bind(this, key, 'debitMarginBaseRate')}
                          name={`debitPremium_${key}`}
                          disabled={this.props.disabled}
                          value='true'
                          _value={typeof item.baseRateDebit !== 'undefined' ? item.baseRateDebit.marginBaseRate : ''}
                        />
                        {this.translations(this.state.detailSettingJson.staticText_detailedSettings.margin)}
                      </label>
                      <label className="radio-group">
                        <Radiobutton
                          setInputvalue={this.setInputvalue.bind(this, key, 'debitFixedValue')}
                          name={`debitPremium_${key}`}
                          disabled={this.props.disabled}
                          value='false'
                          _value={typeof item.baseRateDebit !== 'undefined' ? item.baseRateDebit.fixedValue : ''}
                        />
                        {this.translations(this.state.detailSettingJson.staticText_detailedSettings.fixedValue)}
                      </label>
                    </div>
                  </div>
                  <div className="detail-setting--body-section-row border-Bottom">
                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.minInterest)}</label>
                      <input
                        placeholder={this.state.detailSettingJson.staticText_detailedSettings.defaultValue[5]}
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="debitMinInterest"
                        disabled={this.props.disabled}
                        maxLength="10"
                        value={typeof item.baseRateDebit === 'object' ? item.baseRateDebit.minimumInterest : ''}
                      />
                    </div>
                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.maxInterest)}</label>
                      <input
                        placeholder={this.state.detailSettingJson.staticText_detailedSettings.defaultValue[6]}
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="debitMaxInterest"
                        disabled={this.props.disabled}
                        maxLength="10"
                        value={typeof item.baseRateDebit === 'object' ? item.baseRateDebit.maximumInterest : ''}
                      />
                    </div>
                  </div>
                  <div className="detail-setting--body-section-row">
                    <div className="">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.setOdLimit)}</label>
                      <input
                        ref={node => this[`disableODLimit_${key}`] = node}
                        className="od-row-input"
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="odLimit"
                        disabled={checkIsNA(item.odLimit, true) || this.props.disabled}
                        maxLength="10"
                        value={typeof item.odLimit !== 'undefined' ? item.odLimit : 'N/A'}
                      />
                      <div className="gdocs-display-table gdocs-mleft-30">
                        <Checkbox
                          name={`set_${key}`}
                          disabled={this.props.disabled}
                          defaultChecked={checkIsNA(item.odLimit, true)}
                          checked={item.checkODLimit}
                          onChange={(event) => this.setODLimit(event, key)}
                        />
                      </div>
                      {this.translations(this.state.detailSettingJson.staticText_detailedSettings.na)}
                    </div>
                  </div>
                  {/* <div className="detail-setting--body-section-row">
                     <div className="">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.unauthorisedInterestedType)}</label>
                      <span className="gdocs-mleft-30">
                        <label className="radio-group gdocs-mright-30">
                          <Radiobutton
                            setInputvalue={this.setInputvalue.bind(this, key, 'unauthorisedFloatingInterest')}
                            name={`interestType_${key}`}
                            disabled={this.props.disabled}
                            value='marginBaseRate'
                            _value={typeof item.unauthorizedInterestType !== 'undefined' ? item.unauthorizedInterestType : ''}
                          />
                          {this.translations(this.state.detailSettingJson.staticText_detailedSettings.floating)}
                        </label>
                        <label className="radio-group">
                          <Radiobutton
                            setInputvalue={this.setInputvalue.bind(this, key, 'unauthorisedFixedInterest')}
                            name={`interestType_${key}`}
                            disabled={this.props.disabled}
                            value='fixedValue'
                            _value={typeof item.unauthorizedInterestType !== 'undefined' ? item.unauthorizedInterestType : ''}
                          />
                          {this.translations(this.state.detailSettingJson.staticText_detailedSettings.fixed)}
                        </label>
                      </span>
                    </div> 
                  </div>*/}
                  {(item.checkODLimit === false || item.odLimit !== "N/A") && this.state.detailSettingJson.staticText_detailedSettings &&
                    this.state.detailSettingJson.staticText_detailedSettings.guideccrrateUnauthorizedOD ?
                    <Fragment>
                      <h1>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.unouthorisedOD)}</h1>
                      <div className="detail-setting--body-section-row">
                        {this.generateCCRRateBoxJsx({
                          ...this.state.detailSettingJson.staticText_detailedSettings.guideccrrateUnauthorizedOD, formData: item.unauthorizedOD,
                          isAggregate: true, parentFormName: "detailedSettings", formIndex: key
                        }, "ccrrate-ie-detailed-settings")}
                      </div>
                    </Fragment>
                    : null
                  }
                  {/* <div className="detail-setting--body-section-row">
                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.baseRate)}</label>
                      <input
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="unauthorizedODbaseRate"
                        disabled={this.props.disabled}
                        maxLength="50"
                        value={typeof item.unauthorizedOD === 'object' ? item.unauthorizedOD.baseRate : ''}
                      />
                    </div>
                    {!this.props.disabled
                      ? <div className="row-field">
                        <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.code)}</label>
                        <input
                          type="text"
                          onChange={(event) => this.getData(event, key, item)}
                          name="unauthorizedODCode"
                          maxLength="5"
                          value={typeof item.unauthorizedOD === 'object' ? item.unauthorizedOD.baseRateCode : ''}
                          placeholder={this.state.detailSettingJson.staticText_detailedSettings.defaultValue && this.state.detailSettingJson.staticText_detailedSettings.defaultValue[1]}
                        />
                      </div>
                      : ''}

                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.spread)}</label>
                      <input
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="unauthorizedODSpread"
                        disabled={this.props.disabled}
                        maxLength="7"
                        value={typeof item.unauthorizedOD === 'object' ? item.unauthorizedOD.spread : ''}
                      />
                    </div>
                    <div className="row-field select-radio">
                      <label className="radio-group gdocs-mright-30">
                        <Radiobutton
                          name={`unauthorizedOD_${key}`}
                          disabled={this.props.disabled}
                          value='true'
                          _value={typeof item.unauthorizedOD !== 'undefined' ? item.unauthorizedOD.marginBaseRate : ''}
                          setInputvalue={this.setInputvalue.bind(this, key, 'unauthorizedODMarginBaseRate')}
                        />
                        {this.translations(this.state.detailSettingJson.staticText_detailedSettings.margin)}
                      </label>
                      <label className="radio-group">
                        <Radiobutton
                          name={`unauthorizedOD_${key}`}
                          disabled={this.props.disabled}
                          value='false'
                          _value={typeof item.unauthorizedOD !== 'undefined' ? item.unauthorizedOD.fixedValue : 'false'}
                          setInputvalue={this.setInputvalue.bind(this, key, 'unauthorizedODFixedValue')}
                        />
                        {this.translations(this.state.detailSettingJson.staticText_detailedSettings.fixedValue)}
                      </label>
                    </div>
                  </div> */}
                  {/* <div className="detail-setting--body-section-row">
                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.minInterest)}</label>
                      <input
                        placeholder={this.state.detailSettingJson.staticText_detailedSettings.defaultValue[5]}
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="unauthorizedODMinInterest"
                        disabled={this.props.disabled}
                        maxLength="10"
                        value={typeof item.unauthorizedOD === 'object' ? item.unauthorizedOD.minimumInterest : ''}
                      />
                    </div>
                    <div className="row-field">
                      <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.maxInterest)}</label>
                      <input
                        placeholder={this.state.detailSettingJson.staticText_detailedSettings.defaultValue[6]}
                        type="text"
                        onChange={(event) => this.getData(event, key, item)}
                        name="unauthorizedODMaxInterest"
                        disabled={this.props.disabled}
                        maxLength="10"
                        value={typeof item.unauthorizedOD === 'object' ? item.unauthorizedOD.maximumInterest : ''}
                      />
                    </div>
                  </div> */}
                  {
                    typeof item.tiers !== 'undefined' ? item.tiers.map((tier, index) =>
                      <div>
                        <h1 className="title">{this.translations(this.state.detailSettingJson.staticText_detailedSettings.tier)} {index + 1}</h1>
                        <div className="detail-setting--body-section-row">
                          <div className="row-field">
                            <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.enhanceMarginText)}</label>
                            <input
                              type="text"
                              onChange={this.setTiersData.bind(this, tier, index, key)}
                              name='balanceForEnhancementMargin'
                              disabled={this.props.disabled}
                              value={tier.balanceForEnhancementMargin}
                              maxLength={this.state.detailSettingJson.staticText_detailedSettings.maxChars[0]}
                            />
                          </div>
                          {
                            this.props.premiumMargin && item.premiumMargin &&
                            <div className="row-field">
                              <label>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.premiumMarginText)}</label>
                              <input
                                type="text"
                                onChange={this.setTiersData.bind(this, tier, index, key)}
                                name='balanceEligibleAccountsForPremiumMargin'
                                disabled={this.props.disabled}
                                value={tier.balanceEligibleAccountsForPremiumMargin}
                                maxLength={this.state.detailSettingJson.staticText_detailedSettings.maxChars[0]}
                              />
                            </div>
                          }
                        </div>
                      </div>
                    ) : ''
                  }
                  <div className="detail-setting--footer-section">
                    <div className="footer">
                      <button className="footer-btn" disabled={this.props.disabled} onClick={this.dublicateSettings.bind(key, item)}>{this.translations(this.state.detailSettingJson.staticText_detailedSettings.duplicate)}</button>
                      <label className="gdocs-mleft-30">{this.translations(this.state.detailSettingJson.staticText_detailedSettings.accountSharingText)}</label>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        ), <div className="gdocs-clear-float"></div>,
        <div key="buttons-wrapper" className="form-buttons-save-section">
          <div className="form-buttons-wrapper">
            <button
              className="gdocs-btn-submit"
              onClick={this.props.ieDetailSettingTabData}
            >{this.translations(this.state.detailSettingJson.guidebutton_save.text)}</button>
          </div>
        </div>
      ]
    } else {
      return false;
    }
  }
}

export default IEDetailSetting



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/IEDetailSetting/index.js